export const backgroundImageStyles = {
  backgroundImage: 'url(' + process.env.PUBLIC_URL + '/img/líneasder.svg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};
